'use client';

import { useEffect, useState } from 'react';

import { useDebouncedValue } from '../useDebounce';

import {
  useSearchedSkillQuery,
  useStaticSkillQuery,
} from '@/entities/profile/models';
import { StaticSkillItem } from '@/shared/types';

const useAutoComplete = () => {
  const [selectedSkill, setSelectedSkill] = useState<string[]>([]);
  const [skillQuery, setSkillQuery] = useState<string>('');
  const debouncedSkillQuery = useDebouncedValue(skillQuery, 300);
  const [staticSkillItems, setStaticSkillItems] = useState<StaticSkillItem[]>(
    []
  );
  const [skillErrorMessage, setSkillErrorMessage] = useState<string>('');

  const { data: staticSkillData } = useStaticSkillQuery();
  const { data: searchedSkillData } = useSearchedSkillQuery({
    query: debouncedSkillQuery,
    selected: selectedSkill,
  });

  const handleSkillDelete = (item: string) => {
    setSelectedSkill(
      selectedSkill.filter(
        (selectedItem) => selectedItem !== item.toLowerCase()
      )
    );
  };

  const handleSkillInput = (value: string) => {
    setSelectedSkill((prev) =>
      Array.from(new Set([...prev, value.toLowerCase()]))
    );
    setSkillErrorMessage('');
    setSkillQuery('');
  };

  useEffect(() => {
    if (staticSkillData) {
      setStaticSkillItems(
        staticSkillData.filter(
          (skill) =>
            skill.key.includes(debouncedSkillQuery.toLowerCase()) &&
            !selectedSkill.includes(skill.key)
        )
      );
    }
  }, [debouncedSkillQuery, staticSkillData, selectedSkill]);

  return {
    selectedSkill,
    staticSkillItems,
    skillQuery,
    searchedSkillData,
    setSkillQuery,
    handleSkillDelete,
    handleSkillInput,
    skillErrorMessage,
    setSkillErrorMessage,
  };
};

export default useAutoComplete;
